import React from 'react';
import '../../../css/Turismo/turismo.css';
import '../../../css/Turismo/lugares-ciudad.css';

const Turismo = () => (
  <div>
    <div className="turismo-portada">
      <div className="turismo-portada-overlay">
        <span>
          CIUDAD DE OLIVA<br />GUÍA TURÍSTICA
        </span>
      </div>
    </div>

    <nav className="menu-turismo">
      <ul className="nav-turismo">
        <li><a href="/turismo/lugares-de-la-ciudad">Lugares de la Ciudad</a></li>
        <li><a href="/turismo/recorre-oliva">Recorré Oliva</a></li>
        <li><a href="/turismo/eventos-anuales">Eventos Anuales</a></li>
        {/* <li><a href="#proximos-eventos">Próximos Eventos</a></li> */}
      </ul>
    </nav>

    {/* Bloque de tarjetas movido desde LugaresCiudad */}
    <div className="row mt-3 contenedor-tarjetas">
      <div className="col-12 col-md-6 col-lg-3">
        <div className="card-referencias">
          <div className="img-referencias">
            <img src={require("../../img/Oficina-de-Turismo.jpg")} alt="Oficina de Turismo" />
            <div className="overlay"></div>
            <div className="text-container">
              <h2 style={{ fontSize: 20 }}>Oficina de Turismo</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 col-lg-3">
        <div className="card-referencias">
          <div className="img-referencias">
            <img src={require("../../img/Terminal01.jpeg")} alt="Terminal de Ómnibus" />
            <div className="overlay"></div>
            <div className="text-container">
              <h2 style={{ fontSize: 20 }}>Terminal de Ómnibus</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 col-lg-3">
        <div className="card-referencias">
          <div className="img-referencias">
            <img src={require("../../img/Mural-Ferrocarril-01.jpeg")} alt="Mural Ferrocarril" />
            <div className="overlay"></div>
            <div className="text-container">
              <h2 style={{ fontSize: 20 }}>Mural Ferrocarril</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 col-lg-3">
        <div className="card-referencias">
          <div className="img-referencias">
            <img src={require("../../img/Museo-1.jpg")} alt="Museo Nacional de Malvinas" />
            <div className="overlay"></div>
            <div className="text-container">
              <h2 style={{ fontSize: 20 }}>Museo Nacional de Malvinas</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Fin bloque tarjetas */}

  </div>
);

export default Turismo;
